import { render, staticRenderFns } from "./PmtBenefitPerBusCls.vue?vue&type=template&id=6848317c&"
import script from "./PmtBenefitPerBusCls.vue?vue&type=script&lang=js&"
export * from "./PmtBenefitPerBusCls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports